import { reduxForm, SubmissionError } from 'redux-form'
import { withRouter } from 'react-router-dom'

import flowRight from 'lodash/flowRight'
import moment from 'moment'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { translate } from 'loankeeper-common/helpers'
import transformProps from 'loankeeper-common/containers/transformProps'
import { fetchSFM, destroy as destroyFetcher } from 'loankeeper-common/helpers/SimpleFetchManager'

import { LKModalContainer, actions as LKModalActions } from '../../shared/LKModal'

import { printReport } from '../helpers'
import {
  FORM_NAME,
  CHECK_CREDIT_ACCOUNT_FETCHER_NAME,
  CHECK_DEBIT_ACCOUNT_FETCHER_NAME,
  GET_DEBIT_ACCOUNT_BALANCE_FETCHER_NAME,
  GET_CREDIT_ACCOUNT_BALANCE_FETCHER_NAME,
  ORDER_ADD_FETCHER_INSTANCE,
} from './constants'

import commonContainers from '../containers/common'
import { accEntryAdd } from 'src/store/accEntry'

const translateLKMessage = (key: string): string => translate(`LKMESSAGE-${key}`)

export const reduxFormContainer = reduxForm({
  form: FORM_NAME,

  validate: (values: {
    DocDate: string
    CCY: string
    OpCodeID: number
    OpenAgain: boolean
    action: string
    DebitAccNo: string
    print: string
    Authorize: string
    DocNo: string
    CreditAccNo: string
    Amount: number
    Comment: string
    DebitAccHash: string
    DebitAccID: number
    DebitChosenAccNo: number
    DebitTitleUNI: string
    CreditAccID?: number
  }) => {
    const errors: {
      [key: string]: string
    } = {}

    if (!values.DebitAccID) {
      errors.DebitAccNo = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
    }

    if (!values.CreditAccID) {
      errors.CreditAccNo = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
    }

    if (!values.Amount) {
      errors.Amount = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
    }

    if (!values.DocDate) {
      errors.DocDate = translate('LKMESSAGE-ERR_REQUIRED_FIELD_DATE')
    }

    if (values.Amount > 100000000) {
      errors.Amount = `${translate('LKMESSAGE-HINT_PROD_MAX')}100000000`
    }

    if (values.DocDate && !LKDate.isValid(values.DocDate)) {
      errors.DocDate = translate('LKMESSAGE-ERR_REQUIRED_FIELD_DATE')
    }

    return errors
  },

  onSubmit: (values, dispatch, ownProps) => {
    if (
      moment(values.DocDate, 'DD.MM.YYYY').isBefore(moment(ownProps.OpenDay, 'DD.MM.YYYY')) &&
      !ownProps.permissions.MAKE_CLOSEDAY_ENTRIES
    ) {
      dispatch(LKModalActions.openInfo(translate('LKMESSAGE-ERR_ACCESS_DENIED')))

      return Promise.reject(new SubmissionError({ DocDate: 'invalid' }))
    }

    const apiArgs = {
      ...values,
      OperTypeID: 1,
      DebitAccID: values.DebitAccID,
      HashSum_DebitAccID_: values.DebitAccHash,
      CreditAccID: values.CreditAccID,
      HashSum_CreditAccID_: values.CreditAccHash,
      LoanID: ownProps.params && ownProps.params.LoanID,
      HashSum_LoanID_: ownProps.params && ownProps.params.LoanHash,
    }

    delete apiArgs.CCY
    delete apiArgs.DebitAccNo
    delete apiArgs.DebitTitleUNI
    delete apiArgs.DebitAccHash
    delete apiArgs.DebitChosenAccNo
    delete apiArgs.DebitAccBalance
    delete apiArgs.CreditAccNo
    delete apiArgs.CreditTitleUNI
    delete apiArgs.CreditAccHash
    delete apiArgs.CreditChosenAccNo
    delete apiArgs.CreditAccBalance
    delete apiArgs.print

    if (ownProps.params) {
      apiArgs.EntryID = ownProps.params.ID
      apiArgs.HashSum_EntryID_ = ownProps.params.hash
      apiArgs.OID = ownProps.params.OID
      apiArgs.HashSum_OID_ = ownProps.params.OIDHash
    }

    if (ownProps.name === 'MemorialOrderCopy' && ownProps.OperTypeID === 1) {
      delete apiArgs.HashSum_EntryID_
      delete apiArgs.OID
      delete apiArgs.EntryID
    }

    // return dispatch(
    //   fetchSFM({
    //     instanceName: ORDER_ADD_FETCHER_INSTANCE,
    //     callApi: (params) => {return Order.add(params)},
    //     callApiArgs: [apiArgs],
    //     // callApiArgs: [{}],
    //   }),
    // )

    //UPDATED API REQUEST acc_entry_add_api
    return (
      dispatch(accEntryAdd(apiArgs))
        // .then(({ Data: { EntryID, HashSum_EntryID_ } }) => {
        .then((result) => {
          if (!accEntryAdd.fulfilled.match(result)) {
            throw { Error: { Message: result.payload } }
          }
          const { EntryID, HashSum_EntryID_ } = result.payload
          ownProps.closeModal()

          if (ownProps.onOrderAddEdit) {
            ownProps.onOrderAddEdit()
          }

          dispatch([
            destroyFetcher(CHECK_CREDIT_ACCOUNT_FETCHER_NAME),
            destroyFetcher(GET_DEBIT_ACCOUNT_BALANCE_FETCHER_NAME),
            destroyFetcher(CHECK_DEBIT_ACCOUNT_FETCHER_NAME),
            destroyFetcher(GET_CREDIT_ACCOUNT_BALANCE_FETCHER_NAME),
            destroyFetcher(ORDER_ADD_FETCHER_INSTANCE),
          ])

          if (values.OpenAgain) {
            let name = ''

            if (ownProps.OperTypeID === 1 && ownProps.name === 'MemorialOrderCopy') {
              name = 'MemorialOrderAddInNavigation'
            } else {
              name = ownProps.name
            }
            //@ts-ignore
            dispatch(LKModalActions.open({ name }))
          }

          if (values.action === 'add' && values.print === '1') {
            //@ts-ignore
            printReport({
              dispatch,
              OperTypeID: 1,
              page: 'printmemorder',
              printOption: values.printOption,
              EntryID,
              HashSum_EntryID_,
              history: ownProps.history,
            })
          }
        })
        .catch(({ Error }) => {
          return dispatch(LKModalActions.openInfo(translateLKMessage(Error.Message || Error.Text)))
        })
    )
  },
})

export default flowRight(
  LKModalContainer(),

  commonContainers,

  transformProps((props) => ({
    ...props,
    initialValues: {
      DocDate: props.OpenDay,
      CCY: (props.account && props.account.CCY) || 'GEL',
      OpCodeID: props.OpCode[0] ? props.OpCode[0].ID : undefined,
      OpenAgain: false,
      action: 'add',
      DebitAccNo: (props.account && props.account.AccNo) || undefined,
      DebitTitleUNI: (props.account && props.account.TitleUNI) || undefined,
      DebitAccID: (props.account && props.account.ID) || undefined,
      DebitAccHash: (props.account && props.account.hash) || undefined,
      DebitChosenAccNo: (props.account && props.account.AccNo) || undefined,
      DebitAccBalance: (props.account && props.account.Balance) || undefined,
    },
  })),

  withRouter,
  reduxFormContainer,
)
